var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-ear",class:{
    'bg-ear-full': _vm.full,
    'bg-ear-full-scale': _vm.scale,
    'up-close': _vm.upClose,
    'ear-video': _vm.video,
  },style:(("backgroundImage:url('" + _vm.imgSrc + "'); z-index:" + _vm.zIndex + ";"))},[(_vm.video)?_c('video',{attrs:{"poster":require("@/assets/every-ear/0001.png"),"autoplay":"","loop":"","muted":"","playsinline":"","preload":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":_vm.videoSrc,"type":"video/webm"}})]):_c('svg',{attrs:{"viewBox":"0 0 1366 700","width":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }